import { put } from "../../utils/httpClient";

const taskCustomFieldService = () => {
  const prefixApi = "duedates/taskcustomfields";

  const updateTaskCustomField = async (json) => {
    return await put(`/${prefixApi}`, json);
  };

  return {
    updateTaskCustomField,
  };
};

export default taskCustomFieldService;
